import { View } from './view';
import { FormTypes } from '../forms/form-types';
import { Translations } from '../config/translations';

export class OfflinePaymentView extends View {
    renderOfflinePaymentFormFragment() {
        const offlineForm = document.createElement('div');
        offlineForm.setAttribute('id', 'offline-payment-form-block');
        offlineForm.classList.add('df-f', 'df-f-offline');

        offlineForm.innerHTML = '';
        const container = this.getDFContainer();
        container.appendChild(offlineForm);

        const errorField = document.createElement('div');
        errorField.classList.add('form-columns-1', 'offline-form-field', 'df-field');
        errorField.innerHTML = `<fieldset class='form-columns-1 df-fieldset'><label class='error' id='offline_error'></label></fieldset>`;
        offlineForm.appendChild(errorField);
    }

    setVisible(isActive: boolean) {
        const form = this.getHtmlElement('#offline-payment-form-block');
        if (!form) {
            return;
        }
        if (isActive) {
            this.show(form);
            this.showPayNowButton();
        } else {
            this.hide(form);
            this.hidePayNowButton();
        }
    }

    hidePayNowButton() {
        const button = this.getInputElement('#df_buybtn');
        if (button) {
            button.style.display = 'none';
            button.value = Translations.PAY_NOW;
        }
    }

    showPayNowButton() {
        const button = this.getInputElement('#df_buybtn');
        if (button) {
            button.value = Translations.OFFLINE_PAYMENT;
            button.setAttribute('data-label', 'offline_payment');
            button.style.display = 'inline-block';
        }
    }
}
